import { Injectable } from '@angular/core';
import { DataService } from "../../../../shared/session/index";
import { HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class ConfiguracionService {
    constructor(private dataService: DataService) { }

    private obtenerConfiguracionUrl: string = 'configuracion/empresa';

    obtenerConfiguracion(empresaID: number): any {
        let parameters = new HttpParams();
        parameters = parameters.append("empresaID", String(empresaID));
        this.dataService.set(this.obtenerConfiguracionUrl);
        return this.dataService.execGetJson(parameters);
    }
}


